import type { JSX } from "react";
import { useTranslation } from "react-i18next";

interface InboundKpiStripProps {
  docsInRange: number;
  totalReceived: number;
  lastInboundAt: string | null;
}

interface KpiCardProps {
  label: string;
  value: string;
  testId: string;
}

function KpiCard({ label, value, testId }: KpiCardProps): JSX.Element {
  return (
    <div className="flex flex-1 flex-col gap-[var(--sp-1)] rounded-[var(--r-md)] border border-[var(--border-subtle)] bg-[var(--surface-raised)] px-[var(--sp-4)] py-[var(--sp-3)] shadow-[var(--sh-1)]">
      <span className="text-[11px] font-semibold uppercase tracking-[0.06em] text-[var(--text-subtle)]">
        {label}
      </span>
      <span data-testid={testId} className="num text-[20px] font-bold text-[var(--text-primary)]">
        {value}
      </span>
    </div>
  );
}

export function InboundKpiStrip({
  docsInRange,
  totalReceived,
  lastInboundAt,
}: InboundKpiStripProps): JSX.Element {
  const { t, i18n } = useTranslation("inbound_report");

  const fmt = new Intl.NumberFormat(i18n.language);

  const lastInboundDisplay = lastInboundAt
    ? new Date(lastInboundAt).toLocaleString(i18n.language)
    : t("state.none");

  return (
    <div className="mb-[var(--sp-4)] flex gap-[var(--sp-3)]">
      <KpiCard
        label={t("kpi.docs_in_range")}
        value={fmt.format(docsInRange)}
        testId="inbound-kpi-docs-in-range"
      />
      <KpiCard
        label={t("kpi.total_received")}
        value={fmt.format(totalReceived)}
        testId="inbound-kpi-total-received"
      />
      <KpiCard
        label={t("kpi.last_inbound")}
        value={lastInboundDisplay}
        testId="inbound-kpi-last-inbound"
      />
    </div>
  );
}
